import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string';
import type {
  PublicApiKeyCreateRequest,
  PublicApiKeyCreateResponse,
  PublicApiKey,
  PublicApiKeyDto,
  PublicApiKeyCreateResponseDto,
} from './types';

export const getPublicApiKeys = (): Promise<PublicApiKey[]> => {
  return axios
    .get<{ data: PublicApiKeyDto[] }>(`/api/v1/api_key`)
    .then((response) => keysToCamelCase(response.data.data));
};

export const createPublicApiKey = (
  orgId: number,
  data: PublicApiKeyCreateRequest,
): Promise<PublicApiKeyCreateResponse> => {
  return axios
    .post<{ data: PublicApiKeyCreateResponseDto }>(`/api/v1/organizations/${orgId}/api_key`, data)
    .then((response) => keysToCamelCase(response.data.data));
};

export const deletePublicApiKey = (orgId: number, keyId: number): Promise<AxiosResponse> => {
  return axios.delete(`api/v1/organizations/${orgId}/api_key/${keyId}`);
};

// WIP – It will be used for allowance gate
// export const getResources = (userId: number): Promise<UserResources> => {
//   return axios
//     .get(`/api/v1/users/${userId}/resources`)
//     .then((response) => keysToCamelCase(response.data));
// };
